export const jobs = [
  {
    id: "1",
    order: 1,
    title: "Senior Frontend Engineer | Tech Lead",
    dates: "Sep 2024 - Present",
    duties: [
      "Tech Lead and Senior Frontend Engineer for the new mobile app",
      "Focus on lending features and product development",
      "Managing coordination between product, frontend, backend, and cross-functional teams",
      "Leading architectural decisions and code quality standards",
      "Mentoring junior developers and conducting code reviews",
    ],
    company: "Handelsbanken",
    location: "Oslo, Norway (Onsite)",
  },
  {
    id: "2",
    order: 2,
    title: "Senior Frontend Engineer",
    dates: "Jun 2023 - Oct 2024",
    duties: [
      "Developed and maintained frontend features for banking applications",
      "Collaborated with cross-functional teams to deliver high-quality solutions",
      "Implemented modern frontend architecture and best practices",
      "Optimized application performance and user experience",
    ],
    company: "Handelsbanken",
    location: "Oslo, Norway (Onsite)",
  },
  {
    id: "3",
    order: 3,
    title: "Full-stack Developer",
    dates: "Jun 2021 - May 2023",
    duties: [
      "Crafted and deployed robust web applications using Vue, React, and Nuxt",
      "Built efficient backend solutions with Laravel and Node.js",
      "Spearheaded a project that significantly boosted system performance",
      "Managed application deployments and version control using Git and Jira",
      "Collaborated with diverse teams to deliver top-notch software products",
    ],
    company: "Futureworks",
    location: "Oslo, Norway (Onsite)",
  },
  {
    id: "4",
    order: 4,
    title: "Full-stack Developer",
    dates: "Sep 2016 - Jan 2019",
    duties: [
      "Developed full-stack web applications using Vue/Nuxt, React, Angular, Laravel, Node.js, and AWS",
      "Created a comprehensive meditation web application with user progress tracking",
      "Built a transport ticketing web application with payment integration",
      "Developed an e-commerce platform with full shopping cart and checkout functionality",
      "Delivered robust and user-friendly solutions tailored to client needs",
    ],
    company: "Freelance",
    location: "Norway (Remote)",
  },
  {
    id: "5",
    order: 5,
    title: "Web Search Evaluator",
    dates: "May 2013 - May 2016",
    duties: [
      "Improved relevancy and accuracy of search engine results for local search",
      "Focused on mobile-local projects and business listings evaluation",
      "Conducted research evaluation for Bing search engine",
      "Participated in crowd-sourcing quality control initiatives",
      "Analyzed and rated search results to enhance user experience",
    ],
    company: "Appen Butler Hill",
    location: "Oslo Area, Norway (Remote)",
  },
];
